import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, Dumbbell } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <div className="p-4 rounded-full bg-lime-500/10">
            <Dumbbell className="h-16 w-16 text-lime-500" />
          </div>
        </div>
        <h1 className="text-6xl font-bold mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-4">Page Not Found</h2>
        <p className="text-muted-foreground mb-8">
          Looks like this page went for a workout and never came back. 
          Let's get you back on track!
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild className="bg-lime-500 hover:bg-lime-600 text-black">
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/exercises">Browse Exercises</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
